import APIClient from '../lib/APIClient';
import { resolveAll } from '../helpers/LinkMapper';
import Fare from '../records/Fare';
import PromoCodeStore from '../stores/PromoCodeStore';
import OrderStore from '../stores/OrderStore';

const DaySaveService = {

    async search (search) {
        const url = '/jp/day-save';

        const request = {
            date: search.date.format('YYYY-MM-DD'),
            adults: search.adults,
            children: search.children,
            origin: search.origin.nlc,
            destination: search.destinationNlc
        };

        const order = OrderStore.getCurrent();
        const promo = PromoCodeStore.getActive();
        if (promo && !order.hasReachedDiscountLimit(promo.discount)) {
            request.promoCode = promo.promoCode;
        }
        const response = await APIClient.post(url, request);
        return resolveAll(response.result).as(Fare).sortBy((fare) => fare.totalPrice);
    }

};

export default DaySaveService;



// WEBPACK FOOTER //
// ./src/services/DaySaveService.js